import { PRECIP_LATTICE } from "../types/PrecipLattice";

/** Kept apart from the day-file decoder (precipDay.ts): the eager API adapter checks every
 *  manifest with it, and importing it from there would pull the decoder into the initial bundle. */

const SAME = 1e-9;

/** The manifest's `grid` matches PRECIP_LATTICE (|Δ| < 1e-9 on each number, cols/rows exact): a
 *  day file built for any other lattice would decode into the wrong places. */
export function isPrecipLattice(grid: {
	west: number;
	east: number;
	south: number;
	north: number;
	step: number;
	cols: number;
	rows: number;
}): boolean {
	const L = PRECIP_LATTICE;
	return (
		grid.cols === L.cols &&
		grid.rows === L.rows &&
		[
			[grid.west, L.west],
			[grid.east, L.east],
			[grid.south, L.south],
			[grid.north, L.north],
			[grid.step, L.step],
		].every(([a, b]) => Math.abs(a - b) < SAME)
	);
}
